import { Link } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';

export const data = [
  {
    title: "Introduction",
    level: 1,
    content: "Common Formats for Event Reporting - Nursing Home Version 1.0 (CFER-NH V1.0) is one in a series of Common Formats released by AHRQ. It is primarily designed for use in the nursing home environment to gain enhanced understanding about the circumstances surrounding patient safety concerns in that setting. The framework applies a structured approach to the analysis of all nursing home events.",
  },
  {
    level: 1,
    title: "Collect Data",
    content: <><strong>Collect Data from Providers</strong>: Prepare your patient safety event information using the Nursing Home Version 1.0 Common Format. The resources provided below including the Data Dictionary, Users' Guide, and Flow Charts, will help you understand required data elements, answer values, and validation rules before you create your submission files.</>,
    children: [
      {
        title: "Key Resources",
        level: 2,
        cards: [2533, 2553]
      },
      {
        title: "Event Details",
        level: 2,
        children: [
          {
            title: "Generic",
            level: 3,
            content: "The Generic Module sets out the common information to be collected for all patient safety concerns, regardless of the event type or unsafe condition. This category maps out the type of patient safety concern, the circumstances of the event or unsafe condition, patient information (if applicable), and reporter information.",
            cards: [2542, 2540, 2536, 2534]
          },
          {
            title: "Device or Medical/Surgical Supply, Including HIT",
            level: 3,
            mainContentTitle: "Device or Medical/Surgical Supply, Including Health Information Technology (HIT) Event",
            content: "A device or supply event or unsafe condition involves a defect, failure, or incorrect use of a device. A Health Information Technology (HIT) - related event or unsafe condition involves a defect in, or failure or incorrect use of, an HIT device. Patient safety concerns for the Device category include incidents, near misses, and unsafe conditions that occur in a nursing home.",
            cards: [2550, 2549]
          },
          {
            title: "Fall",
            level: 3,
            mainContentTitle: "Fall Event",
            content: "A fall is a sudden, unintended, descent of a patient's/resident's body to the ground or other object (e.g., onto a bed, chair, or bedside mat) that can be assisted or unassisted. Patient safety events for the Fall category include only incidents that occur in a nursing home.",
            cards: [2545, 2544]
          },
          {
            title: "Medication or Other Substance",
            level: 3,
            mainContentTitle: "Medication or Other Substance Event",
            content: "A medication event or unsafe condition involves the processing and/or administration of medications, biological products, nutritional substances, medical gases, contrast media, or radiopharmaceuticals. Patient safety concerns for the Medication or Other Substance category include incidents, near misses, and unsafe conditions that occur in a nursing home.",
            cards: [2538,2537]
          },
          {
            title: "Pressure Injury",
            level: 3,
            mainContentTitle: "Pressure Injury Event",
            content: "A pressure injury is localized damage to the skin and underlying soft tissue usually over a bony prominence or related to a medical or other device. The injury can present as intact skin or an open ulcer and may be painful. The injury occurs as a result of intense and/or prolonged pressure or pressure in combination with shear. The tolerance of soft tissue for pressure and shear may also be affected by microclimate, nutrition, perfusion, co-morbidities and condition of the soft tissue. Patient safety events for the Pressure Injury (Pressure Ulcer) category include only incidents that occur in a nursing home.",
            cards: [2532, 2531]
          }
          
        ]
      }
    ]
  },
  
  {
    level: 1,
    title: "Submit Data",
    content: <><strong>Submit Data to NPSD</strong>: Submit your patient safety event data to the PSOPPC using the Nursing Home Version 1.0 Common Format. These resources walk you through the process for both CDA XML and Alternate Data Submission formats, including an Implementation Guide, Resources Workbook, and Sample Files. For more information before you get started, see the <Link to={PATHS.public['Submit Data']}>Submit Data</Link> page.</>,
    children: [
      {
        title: "Key Resources",
        level: 2,
        cards: [2541, 2551, 2042, 2552, 2753, 2755, 2754],
      },
      {
        title: "Event Details",
        level: 2,
        children: [
          {
            title: "Generic",
            level: 3,
            cards: [2543]
          },
          {
            title: "Device or Medical/Surgical Supply, Including HIT",
            level: 3,
            mainContentTitle: "Device or Medical/Surgical Supply, Including Health Information Technology (HIT) Event",
            cards: [2548, 2547]
          },
          {
            title: "Fall",
            level: 3,
            mainContentTitle: "Fall Event",
            cards: [2546]
          },
          {
            title: "Medication or Other Substance",
            level: 3,
            mainContentTitle: "Medication or Other Substance Event",
            cards: [2539]
          },
          {
            title: "Pressure Injury",
            level: 3,
            mainContentTitle: "Pressure Injury Event",
            cards: [2535]
          },
          {
            title: "Sample Files",
            level: 3,
            cards: [2554]
          }
        
        ]
      }
    ]
  },

]